import React from "react";
import "./ReplyItem.css";
import { Button, Input } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

function ReplyItem({ isReplyCmt = false }) {
  return (
    <>
      <div className={`commentInputArea ${isReplyCmt && "isReplyCmt"}`}>
        <img
          className="commentAvatar"
          src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8YXJ0aXN0fGVufDB8fDB8fA%3D%3D&w=1000&q=80"
        />
        <Input.TextArea
          placeholder="Comment"
          autoSize={{ minRows: 1, maxRows: 10 }}
          size={isReplyCmt ? "small" : "middle"}
          onPressEnter={() => {
            alert("send comment");
          }}
        />
        <Button size={isReplyCmt ? "small" : "middle"} shape="circle">
          <FontAwesomeIcon
            className="sendCommentIcon"
            icon={faPaperPlane}
            onClick={() => alert("send comment")}
          />
        </Button>
      </div>
    </>
  );
}

export default ReplyItem;
